import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { ConfigurationService } from '@app/configuration/configuration.service';
import { Observable, of, filter, switchMap, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthentificationGuardWithForcedLoginService
  
{
  constructor(
    private configurationService: ConfigurationService,
    private authentificationService: AuthentificationService,
    public router: Router,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    return this.configurationService.isDoneLoading.pipe(
      filter(isDone => isDone),
      switchMap(_ => this.isAuthenticated()),
      tap(isAuthenticated => {
        isAuthenticated || this.authentificationService.login(state.url);
      }),
    );
  }

  isAuthenticated(): Observable<boolean> {
    return this.configurationService.isAuthenticated.pipe(
      switchMap(authenticated => {
        if (!authenticated) return of(false);
        return this.authentificationService.authentication.pipe(
          switchMap(authentication => {
            return of(true);
          }),
        );
      }),
    );
  }
}
